import { StyleSheet } from 'react-native'
import STYLES from '../../constants/styles'

export default StyleSheet.create({
    container: {
        ...StyleSheet.absoluteFillObject
        , justifyContent: 'space-between'
        , alignItems: 'center'
    },
    card: {
        backfaceVisibility: 'hidden'
        , backgroundColor: STYLES.BACKGROUND_COLOR
        , position: 'absolute'
        , top: 0
        , justifyContent: 'space-between'
        , alignItems: 'center'
        , padding: 20
    },
    header: {
        flexDirection: 'row'
        , justifyContent: 'space-between'
        , alignSelf: 'stretch'
    },
    headerText: {
        fontSize: 28
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    subHeaderText: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: STYLES.PRIMARY_TEXT_COLOR
    },
    headerPeriodText: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: STYLES.PRIMARY_TEXT_COLOR
    },
    headerMoney: {
        fontSize: 30
        , fontWeight: 'bold'
        , color: STYLES.LIGHT_GREEN
    },
    accHeaderContent: {
        flexDirection: 'row'
        , paddingVertical: 20
    },
    accHeaderLine: {
        borderTopWidth: 1
        , borderColor: 'rgba(102, 102, 102, 0.1)'
    },
    accHeaderContentActive: {
        // backgroundColor: 'grey'
    },
    accHeaderType: {
        flex: 1
        , justifyContent: 'flex-start'
        , alignItems: 'flex-start'
    },
    accHeaderMain: {
        flex: 4
        , justifyContent: 'flex-start'
        , alignItems: 'flex-start'
    },
    accHeaderMainView: {
        flexDirection: 'column'
    },
    accHeaderMainText1: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    accHeaderMainText2: {
        fontSize: 12
        , color: STYLES.PRIMARY_TEXT_COLOR
    },
    accHeaderValue: {
        flex: 2
        , justifyContent: 'flex-start'
        , alignItems: 'flex-end'
    },
    accHeaderValueText: {
        fontSize: 14
        , fontWeight: 'bold'
        , color: STYLES.SECONDARY_TEXT_COLOR
    },
    flipLink: {
        fontSize: 14
        , color: STYLES.PRIMARY_TEXT_COLOR
    }
})



// WEBPACK FOOTER //
// ./src/components/financials/styles.js